import React from 'react';
import styles from './BottomBar.module.scss';
import { RiFacebookCircleLine, RiInstagramLine, RiLinkedinBoxLine, RiYoutubeLine } from 'react-icons/ri';
import { BiCopyright } from 'react-icons/bi';

import { useHistory, Link } from "react-router-dom";
// import Modal from '../Modal/Modal';
// import VersionsChangeLog from '../../Clinic/VersionsChangeLog';

const appVersion = process.env.REACT_APP_VERSION;

const BottomBar = (props) => {
    let history = useHistory();

    const redirectTo = (path) => {
        window.open(path, '_blank');
        // window.location = path;
    }

    return (
        <div>
            <div className={ `${styles[ 'container' ]} ` }>
                <div className={ `${styles[ 'version-num' ]} ` }>
                    { appVersion }
                </div>

                <div className={ `${styles[ 'social' ]} ` }>

                    <div className={ `${styles[ 'social-button' ]} ` }>
                        <div className={ `${styles[ 'link' ]} ` }
                            rel="noreferrer"
                            onClick={ () => redirectTo('https://www.facebook.com/almalasersint') }>
                            <RiFacebookCircleLine />
                        </div>
                    </div>
                    <div className={ `${styles[ 'social-button' ]} ` }>
                        <div className={ `${styles[ 'link' ]} ` }
                            rel="noreferrer"
                            onClick={ () => redirectTo('https://www.youtube.com/channel/UC2VeP2d4WnOyQpuLxMRf0bA') }>
                            <RiYoutubeLine />
                        </div>
                    </div>
                    <div className={ `${styles[ 'social-button' ]} ` }>
                        <div className={ `${styles[ 'link' ]} ` }
                            rel="noreferrer"
                            onClick={ () => redirectTo('https://www.instagram.com/alma.lasers.international/') }>
                            <RiInstagramLine />
                        </div>
                    </div>
                    <div className={ `${styles[ 'social-button' ]} ` }>
                        <div className={ `${styles[ 'link' ]} ` }
                            rel="noreferrer"
                            onClick={ () => redirectTo('https://www.linkedin.com/company/alma-lasers-international/') }>
                            <RiLinkedinBoxLine />
                        </div>
                    </div>
                </div>

                <div className={ `${styles[ 'copyright' ]} ` }>
                    <div className={ styles.terms }>
                        <a href="/#/content/terms" target="_blank" rel="noreferrer">Terms of Service</a>
                        <span>•</span>
                        <a href="/#/content/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>
                        <span>•</span>
                    </div>
                    <div className={ `${styles[ 'link' ]} ` }
                        // to='https://www.almalasers.com/'
                        rel="noreferrer"
                        onClick={ () => redirectTo('https://www.almalasers.com/') }>
                        <BiCopyright />
                        <div className={ `${styles[ 'cp-txt' ]} ` }>
                            Alma Lasers International 2022
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}


export default BottomBar;
